import React from 'react';
import { useTranslation } from 'react-i18next';

import { ContentContainer, Container } from './styles';

const CommonContainer: React.FC = ({ children }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <ContentContainer>{children}</ContentContainer>
    </Container>
  );
};

export default CommonContainer;
